import { useEffect, useState } from "react";
import moment from "moment";
import { useGetVitalsQuery } from "../../redux/service/vitals_service";
import { cloneDeep } from "lodash";
import { FaComments } from "react-icons/fa";
import MainPageDialog from "../../components/mainPageDialog";

export const Vitals = ({ header = true }) => {
  const [vitalsList, setVitalsList] = useState([]);
  const [commentsDaialog, setCommentsDialog] = useState({
    show: false,
    comments: "",
  });

  moment.updateLocale("fr", {
    invalidDate: "-",
  });

  let cols = [
    { title: "Date", key: "date" },
    {
      title: "B.P",
      key: "blood_pressure",
      multiple: true,
      tooltip: "Blood Pressure",
    },
    {
      title: "B.s",
      key: "blood_sugar",
      multiple: true,
      tooltip: "Blood Sugar",
    },
    { title: "Pulse", key: "pulse", multiple: true },
    {
      title: "Temp",
      key: "body_temperature",
      multiple: true,
      tooltip: "Body Temperature",
    },
    {
      title: "Resp",
      key: "respiration",
      multiple: true,
      tooltip: "Respiration",
    },
    {
      title: "O2Sat",
      key: "oxygen_saturation",
      multiple: true,
      tooltip: "Oxygen Saturation",
    },
    { title: "Weight", key: "weight", tooltip: "" },
    { title: "Height", key: "height", tooltip: "" },
    { title: "BSA", key: "bsa" },
    { title: "BMI", key: "bmi" },
    {
      title: "B.G, P.S",
      key: "bg_ps",
      getData: getBgPsData,
      tooltip: "Blood Group / Pain Scale",
    },
  ];

  const { data, refetch, isLoading, isFetching } = useGetVitalsQuery({
    entry_type: "all",
  });

  useEffect(() => {
    if (data?.data && data?.data?.length) {
      setVitalsList(data?.data);
    }
  }, [data]);

  useEffect(() => {
    let listData;
    if (data?.data && data?.data?.length) {
      listData = cloneDeep(data?.data);
    }
    listData?.map((item) => {
      cols.forEach((col) => {
        if (col.getData) {
          item[col.key + "_display"] = col.getData(item);
        } else if (item[col.key]) {
          item[col.key + "_display"] = parseVitalObj(item[col.key], col.key);
        } else {
          if (item.observation_value && item.observation_value.length) {
            item.observation_value.forEach((obs) => {
              if (obs[col.key]) {
                obs[col.key + "_display"] = parseVitalObj(
                  obs[col.key],
                  col.key
                );
              } else if (obs.value && obs.value[col.key]) {
                let txt = "";
                obs.value[col.key].forEach((obsVal) => {
                  txt += "<p>";
                  txt += parseVitalObj(obsVal, col.key);
                  txt += "</p>";
                });
                obs.value[col.key + "_display"] = txt;
              }
            });
          }
        }
      });
    });
    setVitalsList(listData);
  }, [data]);

  function parseVitalObj(obj, key) {
    var itemFormated = "";
    if (obj && obj.color) {
      var splitValue = [];
      if (typeof obj.value == "string" && obj.value.indexOf("/") > -1) {
        splitValue = obj.value.split("/");
      }
      if (key == "blood_sugar") {
        if (!obj.sub_val) {
          return "<td>&nbsp;</td>";
        }

        if (obj.color == "low") {
          itemFormated = '<td className="itemLow">' + obj.sub_val;
        } else if (obj.color == "high") {
          itemFormated = '<td className="itemHigh">' + obj.sub_val;
        } else if (obj.color == "normal") {
          itemFormated = "<td>" + obj.sub_val;
        }

        itemFormated = itemFormated + " mg/dL</td>";
        if (obj.value == "fasting") {
          itemFormated += '<td title="Fasting"> (F)</td>';
        } else {
          itemFormated += '<td title="Postprandial"> (PP)</td>';
        }
        return itemFormated;
      }

      if (obj.color == "low") {
        itemFormated = '<td className="itemLow">' + obj.value;
      } else if (obj.color == "high") {
        itemFormated = '<td className="itemHigh">' + obj.value;
      } else if (obj.color == "normal/normal") {
        itemFormated = "<td>" + splitValue[0] + "</td>/<td>" + splitValue[1];
      } else if (obj.color == "normal/high") {
        itemFormated =
          "<td>" +
          splitValue[0] +
          '</td>/<td className="itemHigh">' +
          splitValue[1];
      } else if (obj.color == "high/normal") {
        itemFormated =
          '<td className="itemHigh">' +
          splitValue[0] +
          "</td>/<td>" +
          splitValue[1];
      } else if (obj.color == "normal/low") {
        itemFormated =
          "<td>" +
          splitValue[0] +
          '</td>/<td className="itemLow">' +
          splitValue[1];
      } else if (obj.color == "low/normal") {
        itemFormated =
          '<td className="itemLow">' +
          splitValue[0] +
          "</td>/<td>" +
          splitValue[1];
      } else if (obj.color == "high/low") {
        itemFormated =
          '<td className="itemHigh">' +
          splitValue[0] +
          '</td>/<td className="itemLow">' +
          splitValue[1];
      } else if (obj.color == "low/high") {
        itemFormated =
          '<td className="itemLow">' +
          splitValue[0] +
          '</td>/<td className="itemHigh">' +
          splitValue[1];
      } else if (obj.color == "low/low") {
        itemFormated =
          '<td className="itemLow">' +
          splitValue[0] +
          '</td>/<td className="itemLow">' +
          splitValue[1];
      } else if (obj.color == "high/high") {
        itemFormated =
          '<td className="itemHigh">' +
          splitValue[0] +
          '</td>/<td className="itemHigh">' +
          splitValue[1];
      } else {
        itemFormated = '<td className="wrong">' + obj.value;
      }
    } else if (key == "date") {
      return moment(obj).format("hh:mm A");
    } else {
      return (itemFormated = "<td>&nbsp;</td>");
    }
    if (
      (obj.sub_unit == "oz" || obj.sub_unit == "in") &&
      obj.sub_val &&
      obj.sub_val > 0
    ) {
      // itemFormated = '';
      return (itemFormated =
        itemFormated +
        " <td>" +
        obj.unit +
        "</td>  <td>" +
        obj.sub_val +
        " " +
        obj.sub_unit +
        "</td></td>");
    } else if (key == "oxygen_saturation" && obj.sub_val) {
      // itemFormated = '';
      return (itemFormated =
        itemFormated +
        " <td>" +
        obj.unit +
        '</td>  <td className="capitalize">' +
        obj.sub_val +
        "</td></td>");
    } else if (key == "respiration" && obj.value) {
      return (itemFormated = itemFormated + " <td> " + obj.unit + "</td>");
    } else {
      return itemFormated + " " + obj.unit + "</td>";
    }
  }
  function getBgPsData(item) {
    return (
      ((item.blood_type
        ? item.blood_type.value
        : "-") +
      " / " +
      (item.pain_scale?.value ? item.pain_scale.value : "-")).toUpperCase()
    );
  }

  return (
    <>
      {header && (
        <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Vitals
            </h3>
          </div>
          <div className=" flex-shrink-0">
            <button
              type="button"
              onClick={refetch}
              className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Reload
            </button>
          </div>
        </div>
      )}
      {commentsDaialog.show && (
        <MainPageDialog
          title="Comments"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () =>
                setCommentsDialog({
                  show: false,
                  comments: "",
                }),
            },
          ]}
          onCancelHandler={() =>
            setCommentsDialog({
              show: false,
              comments: "",
            })
          }
        >
          {commentsDaialog?.comments}
        </MainPageDialog>
      )}
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <div className="flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-4 lg:-mx-6">
            <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-6">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      {cols?.map((col, colIndex) => (
                        <th
                          key={`col_title_${colIndex}`}
                          scope="col"
                          className="py-3.5 px-3 text-left text-sm text-slate-500"
                        >
                          {col.title}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {vitalsList?.map((item) => (
                    <tbody>
                      <tr>
                        <td
                          className="whitespace-nowrap py-2 px-3 font-bold text-[#4e9beb] border-b"
                          colSpan={cols.length}
                        >
                          <div className="flex items-center gap-4">
                            {moment(item?.created).format("MM/DD/YY hh:mm A")}{" "}
                            By {item?.updated_by_name}
                            {item?.patient_instructions && (
                              <span
                                onClick={() =>
                                  setCommentsDialog({
                                    show: true,
                                    comments: item?.patient_instructions,
                                  })
                                }
                                className="cursor-pointer"
                              >
                                <FaComments />
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                      {item?.observation_value?.map((obs, obsIndex) => (
                        <tr>
                          {cols?.map((col) => (
                            <>
                              {obs[col.key + "_display"] ? (
                                <td
                                  className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900"
                                  dangerouslySetInnerHTML={{
                                    __html: obs[col.key + "_display"],
                                  }}
                                ></td>
                              ) : obs?.value[col.key + "_display"] ? (
                                <td
                                  className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900"
                                  dangerouslySetInnerHTML={{
                                    __html: obs.value[col.key + "_display"],
                                  }}
                                ></td>
                              ) : item[col.key + "_display"] &&
                                obsIndex == 0 ? (
                                <td
                                  className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900"
                                  dangerouslySetInnerHTML={{
                                    __html: item[col.key + "_display"],
                                  }}
                                ></td>
                              ) : (
                                <td></td>
                              )}
                            </>
                          ))}
                        </tr>
                      ))}
                      {!item?.observation_value?.length && (
                        <tr>
                          {cols?.map((col) => (
                            <>
                              {item[col.key + "_display"] ? (
                                <td
                                  className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900"
                                  dangerouslySetInnerHTML={{
                                    __html: item[col.key + "_display"],
                                  }}
                                ></td>
                              ) : (
                                <td></td>
                              )}
                            </>
                          ))}
                        </tr>
                      )}
                    </tbody>
                  ))}
                  {!vitalsList?.length && isFetching == false && (
                    <p className="p-2">No data found</p>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
